/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  highway: [],
  'common/states': [],
  'common/unit_measurement': [],
  currency: [],
  customer: [],
  'customer/customertype': [],
  'customer/typecustomerstaff': [],
  highwaycompany: [],
  'highway/highwaydelegation': [],
  'highway/tollbooth': [],
  'highway/camp': [],
  'highway/highwaysection': [],
  crew:[],
  allocationfiles:[],
  filetype:[],
  'services/details': [],
  'services/families': [],
  'services/subfamilies':[],
  'services/supplies':[],
  providers: [],
  supplycamp: [],
  'macro/Carreteras/process': [],
  'macro/Carreteras/business_cicle': [],
  'macro/Carreteras/status': [],
}


// WEBPACK FOOTER //
// ./src/store/modules/catalogs/state.js